import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { redirectAuthenticatedUser } from '../../actions/user'

export function wrapUnauthenticatedComponent (WrappedComponent) {
  const UnauthenticatedComponent = props => {
    const dispatch = useDispatch()

    useEffect(() => {
      if (
        sessionStorage.getItem('oef-token') &&
        !sessionStorage.getItem('password')
      ) {
        dispatch(redirectAuthenticatedUser())
      }
    })

    return (
      <React.Fragment>
        <WrappedComponent {...props} />
        <div className="oe-container">
          <div
            className="oe-logo"
            onClick={() =>
              window.open('https://www.opportunityeducation.org/')
            }
          />
        </div>
      </React.Fragment>
    )
  }

  UnauthenticatedComponent.propTypes = {
    location: PropTypes.object.isRequired
  }

  return connect()(UnauthenticatedComponent)
}



// WEBPACK FOOTER //
// ./src/containers/HOC/UnauthenticatedComponent.js